<!--视频上传-->
<template>
  <div>
    <el-row :gutter="20">
      <el-col :span="8" :offset="0">
        <div style="border: 1px solid #c5d0e2; border-radius: 2px; padding: 16px">
          <div style="color: #0f1a3a; font-weight: bold; font-size: 12px; margin-bottom: 16px">
            {{ $t("videom.upload_params") }}
          </div>
          <el-form :model="uploadForm" label-width="100px" size="small">
            <el-form-item :label="$t('videom.select_vehicle')">
              <el-select style="width: 100%" filterable v-model="uploadForm.deviceNo" :placeholder="$t('public.select')"
                @change="onVehicleChange">
                <el-option v-for="item in vehicleData" :key="item.DeviceNo" :label="item.CarNo" :value="item.DeviceNo">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item :label="$t('videom.select_channel')">
              <el-select style="width: 100%" v-model="uploadForm.channel" :placeholder="$t('public.select')">
                <el-option v-for="item in channelData" :key="item.ChannelNo" :label="item.ChannelNo"
                  :value="item.ChannelNo">
                </el-option>
              </el-select>
            </el-form-item>
            <!--<el-form-item :label="$t('videom.resource_type')">
              <el-select style="width: 100%" v-model="uploadForm.resourceType" :placeholder="$t('public.select')">
                <el-option :label="$t('videom.audio_video')" :value="0"></el-option>
                <el-option :label="$t('videom.audio')" :value="1"></el-option>
                <el-option :label="$t('videom.video')" :value="2"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item :label="$t('videom.coded_type')">
              <el-select style="width: 100%" v-model="uploadForm.codedType" :placeholder="$t('public.select')">
                <el-option :label="$t('videom.coded_type_all')" :value="0"></el-option>
                <el-option :label="$t('videom.coded_type_main')" :value="1"></el-option>
                <el-option :label="$t('videom.coded_type_sub')" :value="2"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item :label="$t('videom.memory_position')">
              <el-select style="width: 100%" v-model="uploadForm.memoryPosition" :placeholder="$t('public.select')">
                <el-option :label="$t('videom.memory_position_all')" :value="0"></el-option>
                <el-option :label="$t('videom.memory_position_main')" :value="1"></el-option>
                <el-option :label="$t('videom.memory_position_backup')" :value="2"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item :label="$t('videom.alarm_flag')">
              <el-input v-model="uploadForm.alarmFlag" :placeholder="$t('videom.alarm_flag_holder')"></el-input>
            </el-form-item>-->
            <el-form-item :label="$t('龙翼简报.选择日期')">
              <el-date-picker v-model="uploadForm.beginDate" type="date" style="width: 100%"
                :placeholder="$t('龙翼简报.选择日期')" format="yyyy-MM-dd" value-format="yyyy-MM-dd">
              </el-date-picker>
            </el-form-item>
            <el-form-item :label="$t('time.startTimeHolder')">
              <el-time-picker v-model="uploadForm.beginTime" style="width: 100%"
                :placeholder="$t('time.startTimeHolder')" format="HH:mm:ss" value-format="HH:mm:ss">
              </el-time-picker>
            </el-form-item>
            <el-form-item :label="$t('time.endTimeHolder')">
              <el-time-picker v-model="uploadForm.endTime" style="width: 100%" :placeholder="$t('time.endTimeHolder')"
                format="HH:mm:ss" value-format="HH:mm:ss">
              </el-time-picker>
            </el-form-item>
            <el-form-item :label="$t('videom.server_ip')">
              <el-input v-model="uploadForm.serverIP" :placeholder="$t('videom.server_ip_holder')"></el-input>
            </el-form-item>
            <el-form-item :label="$t('videom.server_port')">
              <el-input v-model="uploadForm.serverPort" :placeholder="$t('videom.server_port_holder')"></el-input>
            </el-form-item>
            <el-form-item :label="$t('videom.server_user')">
              <el-input v-model="uploadForm.serverUser" :placeholder="$t('videom.server_user_holder')"></el-input>
            </el-form-item>
            <el-form-item :label="$t('videom.server_password')">
              <el-input v-model="uploadForm.serverPassword" show-password
                :placeholder="$t('videom.server_password_holder')"></el-input>
            </el-form-item>
            <el-form-item :label="$t('videom.file_path')">
              <el-input v-model="uploadForm.filePath" :placeholder="$t('videom.file_path_holder')"></el-input>
            </el-form-item>
            <!--  <el-form-item :label="$t('videom.task_condition')">
              <el-checkbox-group v-model="uploadForm.taskCondition" size="small">
                <el-checkbox :label="1">WiFi</el-checkbox>
                <el-checkbox :label="2">LAN</el-checkbox>
                <el-checkbox :label="4">3G/4G</el-checkbox>
              </el-checkbox-group>
            </el-form-item>-->
            <el-form-item>
              <el-button type="primary" plain @click="startUpload" :loading="uploading">{{ $t("videom.start_upload")
              }}</el-button>
              <el-button plain @click="resetForm">{{ $t("videom.reset") }}</el-button>
            </el-form-item>
          </el-form>
        </div>
      </el-col>
      <el-col :span="16" :offset="0">
        <div style="border: 1px solid #c5d0e2; border-radius: 2px; padding: 16px">
          <div style="display: flex; align-items: center; font-size: 12px; margin-bottom: 16px">
            <div style="color: #0f1a3a; font-weight: bold">
              {{ $t("videom.upload_task_list") }}
            </div>
            <div style="flex: 1; text-align: right">
              <el-button type="text" size="mini" @click="clearTasks">{{ $t("videom.clear_tasks") }}</el-button>
            </div>
          </div>
          <div style="height: calc(100vh - 250px); overflow-y: auto">
            <el-table size="mini" :data="uploadTasks" border style="width: 100%" :row-style="tableRowStyle">
              <el-table-column type="index" width="45" :label="$t('public.index')" align="center">
              </el-table-column>
              <el-table-column prop="vehicleName" align="center" :label="$t('vehicle.carNo')" width="100">
              </el-table-column>
              <el-table-column prop="channel" align="center" :label="$t('videom.channel')" width="65">
              </el-table-column>
              <el-table-column prop="resourceTypeName" align="center" :label="$t('videom.resource_type')" width="80">
              </el-table-column>
              <el-table-column prop="beginTime" align="center" :label="$t('time.startTimeHolder')" width="145">
              </el-table-column>
              <el-table-column prop="endTime" align="center" :label="$t('time.endTimeHolder')" width="145">
              </el-table-column>
              <el-table-column prop="filePath" align="center" :label="$t('videom.file_path')" show-overflow-tooltip>
              </el-table-column>
              <el-table-column prop="statusName" align="center" :label="$t('videom.upload_status')" width="90">
                <template slot-scope="scope">
                  <span :style="getStatusStyle(scope.row.status)">{{ scope.row.statusName }}</span>
                </template>
              </el-table-column>
              <el-table-column prop="msg" align="center" :label="$t('videom.upload_result')" width="120"
                show-overflow-tooltip>
              </el-table-column>
            </el-table>
          </div>
        </div>
      </el-col>
    </el-row>
  </div>
</template>
<script>
export default {
  props: {
    vehicleData: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      uploading: false,
      channelData: [
        { ChannelNo: 1 },
        { ChannelNo: 2 },
        { ChannelNo: 3 },
        { ChannelNo: 4 },
        { ChannelNo: 5 },
        { ChannelNo: 6 },
        { ChannelNo: 7 },
        { ChannelNo: 8 },
      ],
      uploadForm: {
        deviceNo: "",
        vehicleName: "",
        channel: 1,
        resourceType: 0,
        codedType: 0,
        memoryPosition: 0,
        alarmFlag: "0",
        beginDate: "",
        beginTime: "",
        endTime: "",
        serverIP: "",
        serverPort: "",
        serverUser: "",
        serverPassword: "",
        filePath: "/devicevideo",
        taskCondition: [1, 2, 4],
      },
      uploadTasks: [],
    };
  },
  created() {
    this.socketClient.AttachEvent(
      "VideoUploadMgr",
      this.socketClient.eventType.onMultiMediaFileUploadAck,
      this.onMultiMediaFileUploadAck
    );
  },
  beforeDestroy() {
    this.socketClient.DetachEvent(
      "VideoUploadMgr",
      this.socketClient.eventType.onMultiMediaFileUploadAck
    );
  },
  methods: {
    onVehicleChange(val) {
      var s = this.vehicleData.filter((item) => item.DeviceNo === val);
      if (s && s.length > 0) {
        this.uploadForm.vehicleName = s[0].CarNo;
      }
    },
    tableRowStyle() {
      return { cursor: "default" };
    },
    getResourceTypeName(type) {
      switch (type) {
        case 0:
          return this.$t("videom.audio_video");
        case 1:
          return this.$t("videom.audio");
        case 2:
          return this.$t("videom.video");
        default:
          return "";
      }
    },
    getStatusStyle(status) {
      // 0-等待 1-上传中 2-成功 3-失败
      switch (status) {
        case 2:
          return { color: "#67c23a", fontWeight: "bold" };
        case 3:
          return { color: "#f56c6c", fontWeight: "bold" };
        case 1:
          return { color: "#409eff", fontWeight: "bold" };
        default:
          return { color: "#909399" };
      }
    },
    validateForm() {
      if (!this.uploadForm.deviceNo) {
        this.$message.error(this.$t("videom.pls_select_vehicle"));
        return false;
      }
      if (!this.uploadForm.beginDate || !this.uploadForm.beginTime || !this.uploadForm.endTime) {
        this.$message.error(this.$t("time.selectQueryTime"));
        return false;
      }
      if (this.moment(this.uploadForm.endTime).isBefore(this.moment(this.uploadForm.beginTime))) {
        this.$message.error(this.$t("videom.time_range_error"));
        return false;
      }
      return true;
    },
    formatTimeToBCD(timeStr) {
      //将 yyyy-MM-dd HH:mm:ss 转为 YYMMDDHHMMSS
      if (!timeStr) return "";
      var t = this.moment(timeStr);
      return t.format("YYYYMMDDHHmmss");
    },
    startUpload() {
      if (!this.validateForm()) return;

      var beginTimeBCD = this.formatTimeToBCD(this.uploadForm.beginDate + " " + this.uploadForm.beginTime);
      var endTimeBCD = this.formatTimeToBCD(this.uploadForm.beginDate + " " + this.uploadForm.endTime);
      var filePath = this.uploadForm.filePath || "";
      //任务条件 bitmask: bit0=WiFi bit1=LAN bit2=3G/4G
      var taskConditionValue = this.uploadForm.taskCondition.reduce(
        (a, b) => a | b, 0
      );

      //todo 测试
      // this.uploadForm.deviceNo = '004010007523'
      // this.uploadForm.serverIP = '106.12.111.46'
      // this.uploadForm.serverPort = 15100
      // this.uploadForm.serverUser = 'apolocan'
      // this.uploadForm.serverPassword = 'apolo066psw'
      // filePath = '/devicevideo/' + this.uploadForm.deviceNo
      // this.uploadForm.channel = 1
      // beginTimeBCD = '20260814105040'
      // beginTimeBCD = '20260814104000'
      // endTimeBCD = '20260814105740'
      // endTimeBCD = '20260814110000'
      this.uploadForm.alarmFlag = 0
      this.uploadForm.resourceType = 0
      this.uploadForm.codedType = 0
      this.uploadForm.memoryPosition = 0
      taskConditionValue = 7

      console.log(this.uploadForm);
      console.log(filePath);
      console.log(beginTimeBCD);
      console.log(endTimeBCD);
      console.log(taskConditionValue);
      // return;

      //下发1078协议多媒体文件上传指令 0x9206
      this.socketClient.socket.MultiMediaFileUpload(
        this.uploadForm.deviceNo,
        this.uploadForm.serverIP,
        this.uploadForm.serverPort,
        this.uploadForm.serverUser,
        this.uploadForm.serverPassword,
        filePath,
        this.uploadForm.channel,
        beginTimeBCD,
        endTimeBCD,
        this.uploadForm.alarmFlag,
        this.uploadForm.resourceType,
        this.uploadForm.codedType,
        this.uploadForm.memoryPosition,
        taskConditionValue
      );

      //添加到任务列表
      this.uploadTasks.unshift({
        deviceNo: this.uploadForm.deviceNo,
        vehicleName: this.uploadForm.vehicleName,
        channel: this.uploadForm.channel,
        resourceType: this.uploadForm.resourceType,
        resourceTypeName: this.getResourceTypeName(this.uploadForm.resourceType),
        beginTime: this.uploadForm.beginDate + " " + this.uploadForm.beginTime,
        endTime: this.uploadForm.beginDate + " " + this.uploadForm.endTime,
        filePath: filePath,
        status: 0,
        statusName: this.$t("videom.status_waiting"),
        msg: "",
        beginTimeBCD: beginTimeBCD,
        endTimeBCD: endTimeBCD,
      });

      this.uploading = true;
      this.$message.success(this.$t("videom.upload_cmd_sent"));

      //超时处理
      setTimeout(() => {
        this.uploading = false;
        var pendingTask = this.uploadTasks.find(
          (t) =>
            t.deviceNo === this.uploadForm.deviceNo &&
            t.channel === this.uploadForm.channel &&
            t.status === 0
        );
        if (pendingTask) {
          pendingTask.status = 3;
          pendingTask.statusName = this.$t("videom.status_failed");
          pendingTask.msg = this.$t("videom.upload_timeout");
        }
      }, 30000);
    },
    onMultiMediaFileUploadAck(v_params) {
      //0x9206 多媒体文件上传指令应答
      var resultMsg = "";
      var result = v_params.result;
      switch (result) {
        case 0:
          resultMsg = "";
          break;
        case 1:
          resultMsg = this.$t("public.Fail");
          break;
        case 2:
          resultMsg = this.$t("deviceresponse.msgError");
          break;
        case 3:
          resultMsg = this.$t("deviceresponse.noSupport");
          break;
        case 0x80:
          resultMsg = this.$t("deviceresponse.offLine");
          break;
        case 0x81:
          resultMsg = this.$t("deviceresponse.noAnswer");
          break;
      }

      var mobile = v_params.mobile;
      var task = this.uploadTasks.find(
        (t) => t.deviceNo === mobile && t.status === 0
      );
      if (task) {
        if (result === 0) {
          //设备接受上传指令，标记为上传中
          task.status = 1;
          task.statusName = this.$t("videom.status_uploading");
          task.msg = this.$t("videom.upload_ack_success");
        } else {
          task.status = 3;
          task.statusName = this.$t("videom.status_failed");
          task.msg = resultMsg;
        }
      }
      this.uploading = false;
    },
    resetForm() {
      this.uploadForm.channel = 1;
      this.uploadForm.resourceType = 0;
      this.uploadForm.codedType = 0;
      this.uploadForm.memoryPosition = 0;
      this.uploadForm.alarmFlag = "0";
      this.uploadForm.beginDate = "";
      this.uploadForm.beginTime = "";
      this.uploadForm.endTime = "";
      this.uploadForm.serverIP = "";
      this.uploadForm.serverPort = "";
      this.uploadForm.serverUser = "";
      this.uploadForm.serverPassword = "";
      this.uploadForm.filePath = "";
      this.uploadForm.taskCondition = [1, 2, 4];
    },
    clearTasks() {
      this.uploadTasks = this.uploadTasks.filter((t) => t.status === 0 || t.status === 1);
    },
  },
};
</script>
